import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetListOfProjects() {
  return useQuery(
    ['get-listof-projects'],
    async () => {
      const res = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.LISTOF_PROJECTS)
      );
      return res.data;
    },
    {
      staleTime: 18000,
    }
  );
}
